module.exports = __webpack_public_path__ + "static/media/logo-coloured.7cb24bb9.png";